export const renderTextWithMentions = (
  text: string,
  mention: string[] | string = [],
): (string | React.JSX.Element)[] => {
  const mentionsArray = Array.isArray(mention) ? mention : [mention];
  const mentionsWithAt = mentionsArray
    .filter((m) => m.trim() !== "")
    .map((mention) => (mention.startsWith("@") ? mention : `@${mention}`));

  // If no mentions to highlight, return the text as is
  if (mentionsWithAt.length === 0) {
    return [text];
  }

  // Slack-like mention matching: word boundaries around @mention, excluding email addresses
  const mentionRegex = new RegExp(`(?<![a-zA-Z0-9_])(${mentionsWithAt.join("|")})(?![a-zA-Z0-9_])`, "g");
  const parts = text.split(mentionRegex);

  return parts.map((part, index) => {
    if (mentionsWithAt.includes(part)) {
      return (
        <span key={index} className="text-secondary">
          {part}
        </span>
      );
    }
    return part;
  });
};
